/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { RealizationAssigneeRequestDto } from '../models';
// @ts-ignore
import type { RealizationDepartmentDto } from '../models';
// @ts-ignore
import type { RealizationDepartmentStatusRequestDto } from '../models';
// @ts-ignore
import type { RealizationItemDto } from '../models';
// @ts-ignore
import type { RealizationLogEntryDto } from '../models';
/**
 * RestRealizationApi - axios parameter creator
 */
export const RestRealizationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Realizacja jednej oferty
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealization: async (processOfferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getRealization', 'processOfferId', processOfferId)
            const localVarPath = `/api/realizations/{processOfferId}`
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * PDF zlecenia realizacji; z działem — tylko część tego działu. Pobranie zapisuje się w historii realizacji (kto, kiedy, który dział). 
         * @summary Zlecenie realizacji jednej oferty
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} [department] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationFile: async (processOfferId: string, department?: RealizationDepartmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getRealizationFile', 'processOfferId', processOfferId)
            const localVarPath = `/api/realizations/{processOfferId}/file`
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Od najnowszego wpisu.
         * @summary Historia realizacji jednej oferty
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationHistory: async (processOfferId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getRealizationHistory', 'processOfferId', processOfferId)
            const localVarPath = `/api/realizations/{processOfferId}/history`
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Oferty w statusach widocznych w kalendarzu, których wydarzenie zaczyna się w podanym zakresie (włącznie, daty polskie), posortowane od najwcześniejszego. Każda pozycja niesie kierownika realizacji i listę działów: działy wynikające z treści oferty oraz zawsze Magazyn, każdy ze stanem, osobą odpowiedzialną i ostatnim pobraniem. 
         * @summary Realizacje w zakresie dat
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizations: async (from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getRealizations', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getRealizations', 'to', to)
            const localVarPath = `/api/realizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Jeden PDF ze zleceniami realizacji wszystkich realizacji z zakresu (każda od nowej strony), w kolejności jak w liście. Z działem — tylko strony tego działu i tylko realizacje, które go mają. Każde pobranie zapisuje się w historii każdej z tych realizacji. 
         * @summary Zbiorczy PDF zleceń realizacji
         * @param {string} from 
         * @param {string} to 
         * @param {RealizationDepartmentDto} [department] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationsFile: async (from: string, to: string, department?: RealizationDepartmentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getRealizationsFile', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getRealizationsFile', 'to', to)
            const localVarPath = `/api/realizations/file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            localVarHeaderParameter['Accept'] = 'application/pdf';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wpisy historii realizacji, których wydarzenie zaczyna się w zakresie, od najnowszego.
         * @summary Historia realizacji z zakresu
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationsHistory: async (from: string, to: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'from' is not null or undefined
            assertParamExists('getRealizationsHistory', 'from', from)
            // verify required parameter 'to' is not null or undefined
            assertParamExists('getRealizationsHistory', 'to', to)
            const localVarPath = `/api/realizations/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString().substring(0,10) :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString().substring(0,10) :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Brak userId czyści przypisanie.
         * @summary Osoba odpowiedzialna za dział w realizacji
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} department 
         * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationDepartmentResponsible: async (processOfferId: string, department: RealizationDepartmentDto, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateRealizationDepartmentResponsible', 'processOfferId', processOfferId)
            // verify required parameter 'department' is not null or undefined
            assertParamExists('updateRealizationDepartmentResponsible', 'department', department)
            // verify required parameter 'realizationAssigneeRequestDto' is not null or undefined
            assertParamExists('updateRealizationDepartmentResponsible', 'realizationAssigneeRequestDto', realizationAssigneeRequestDto)
            const localVarPath = `/api/realizations/{processOfferId}/departments/{department}/responsible`
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{department}', encodeURIComponent(String(department)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(realizationAssigneeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Oznacza część działu jako zrobioną, z powrotem do zrobienia albo jako niedotyczącą tej realizacji. Zapamiętuje kto i kiedy. 
         * @summary Stan działu w realizacji
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} department 
         * @param {RealizationDepartmentStatusRequestDto} realizationDepartmentStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationDepartmentStatus: async (processOfferId: string, department: RealizationDepartmentDto, realizationDepartmentStatusRequestDto: RealizationDepartmentStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateRealizationDepartmentStatus', 'processOfferId', processOfferId)
            // verify required parameter 'department' is not null or undefined
            assertParamExists('updateRealizationDepartmentStatus', 'department', department)
            // verify required parameter 'realizationDepartmentStatusRequestDto' is not null or undefined
            assertParamExists('updateRealizationDepartmentStatus', 'realizationDepartmentStatusRequestDto', realizationDepartmentStatusRequestDto)
            const localVarPath = `/api/realizations/{processOfferId}/departments/{department}/status`
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{department}', encodeURIComponent(String(department)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(realizationDepartmentStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ustawia osobę odpowiedzialną za całą realizację; brak userId czyści przypisanie.
         * @summary Kierownik realizacji
         * @param {string} processOfferId 
         * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationLead: async (processOfferId: string, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateRealizationLead', 'processOfferId', processOfferId)
            // verify required parameter 'realizationAssigneeRequestDto' is not null or undefined
            assertParamExists('updateRealizationLead', 'realizationAssigneeRequestDto', realizationAssigneeRequestDto)
            const localVarPath = `/api/realizations/{processOfferId}/lead`
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(realizationAssigneeRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestRealizationApi - functional programming interface
 */
export const RestRealizationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestRealizationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Realizacja jednej oferty
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealization(processOfferId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizationItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealization(processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.getRealization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * PDF zlecenia realizacji; z działem — tylko część tego działu. Pobranie zapisuje się w historii realizacji (kto, kiedy, który dział). 
         * @summary Zlecenie realizacji jednej oferty
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} [department] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealizationFile(processOfferId: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealizationFile(processOfferId, department, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.getRealizationFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Od najnowszego wpisu.
         * @summary Historia realizacji jednej oferty
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealizationHistory(processOfferId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RealizationLogEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealizationHistory(processOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.getRealizationHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Oferty w statusach widocznych w kalendarzu, których wydarzenie zaczyna się w podanym zakresie (włącznie, daty polskie), posortowane od najwcześniejszego. Każda pozycja niesie kierownika realizacji i listę działów: działy wynikające z treści oferty oraz zawsze Magazyn, każdy ze stanem, osobą odpowiedzialną i ostatnim pobraniem. 
         * @summary Realizacje w zakresie dat
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealizations(from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RealizationItemDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealizations(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.getRealizations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Jeden PDF ze zleceniami realizacji wszystkich realizacji z zakresu (każda od nowej strony), w kolejności jak w liście. Z działem — tylko strony tego działu i tylko realizacje, które go mają. Każde pobranie zapisuje się w historii każdej z tych realizacji. 
         * @summary Zbiorczy PDF zleceń realizacji
         * @param {string} from 
         * @param {string} to 
         * @param {RealizationDepartmentDto} [department] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealizationsFile(from: string, to: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealizationsFile(from, to, department, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.getRealizationsFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wpisy historii realizacji, których wydarzenie zaczyna się w zakresie, od najnowszego.
         * @summary Historia realizacji z zakresu
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRealizationsHistory(from: string, to: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RealizationLogEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRealizationsHistory(from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.getRealizationsHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Brak userId czyści przypisanie.
         * @summary Osoba odpowiedzialna za dział w realizacji
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} department 
         * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRealizationDepartmentResponsible(processOfferId: string, department: RealizationDepartmentDto, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizationItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRealizationDepartmentResponsible(processOfferId, department, realizationAssigneeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.updateRealizationDepartmentResponsible']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Oznacza część działu jako zrobioną, z powrotem do zrobienia albo jako niedotyczącą tej realizacji. Zapamiętuje kto i kiedy. 
         * @summary Stan działu w realizacji
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} department 
         * @param {RealizationDepartmentStatusRequestDto} realizationDepartmentStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRealizationDepartmentStatus(processOfferId: string, department: RealizationDepartmentDto, realizationDepartmentStatusRequestDto: RealizationDepartmentStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizationItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRealizationDepartmentStatus(processOfferId, department, realizationDepartmentStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.updateRealizationDepartmentStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ustawia osobę odpowiedzialną za całą realizację; brak userId czyści przypisanie.
         * @summary Kierownik realizacji
         * @param {string} processOfferId 
         * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRealizationLead(processOfferId: string, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RealizationItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRealizationLead(processOfferId, realizationAssigneeRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestRealizationApi.updateRealizationLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestRealizationApi - factory interface
 */
export const RestRealizationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestRealizationApiFp(configuration)
    return {
        /**
         * 
         * @summary Realizacja jednej oferty
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealization(processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto> {
            return localVarFp.getRealization(processOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * PDF zlecenia realizacji; z działem — tylko część tego działu. Pobranie zapisuje się w historii realizacji (kto, kiedy, który dział). 
         * @summary Zlecenie realizacji jednej oferty
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} [department] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationFile(processOfferId: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getRealizationFile(processOfferId, department, options).then((request) => request(axios, basePath));
        },
        /**
         * Od najnowszego wpisu.
         * @summary Historia realizacji jednej oferty
         * @param {string} processOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationHistory(processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RealizationLogEntryDto>> {
            return localVarFp.getRealizationHistory(processOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * Oferty w statusach widocznych w kalendarzu, których wydarzenie zaczyna się w podanym zakresie (włącznie, daty polskie), posortowane od najwcześniejszego. Każda pozycja niesie kierownika realizacji i listę działów: działy wynikające z treści oferty oraz zawsze Magazyn, każdy ze stanem, osobą odpowiedzialną i ostatnim pobraniem. 
         * @summary Realizacje w zakresie dat
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizations(from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RealizationItemDto>> {
            return localVarFp.getRealizations(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Jeden PDF ze zleceniami realizacji wszystkich realizacji z zakresu (każda od nowej strony), w kolejności jak w liście. Z działem — tylko strony tego działu i tylko realizacje, które go mają. Każde pobranie zapisuje się w historii każdej z tych realizacji. 
         * @summary Zbiorczy PDF zleceń realizacji
         * @param {string} from 
         * @param {string} to 
         * @param {RealizationDepartmentDto} [department] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationsFile(from: string, to: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getRealizationsFile(from, to, department, options).then((request) => request(axios, basePath));
        },
        /**
         * Wpisy historii realizacji, których wydarzenie zaczyna się w zakresie, od najnowszego.
         * @summary Historia realizacji z zakresu
         * @param {string} from 
         * @param {string} to 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRealizationsHistory(from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RealizationLogEntryDto>> {
            return localVarFp.getRealizationsHistory(from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * Brak userId czyści przypisanie.
         * @summary Osoba odpowiedzialna za dział w realizacji
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} department 
         * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationDepartmentResponsible(processOfferId: string, department: RealizationDepartmentDto, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto> {
            return localVarFp.updateRealizationDepartmentResponsible(processOfferId, department, realizationAssigneeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Oznacza część działu jako zrobioną, z powrotem do zrobienia albo jako niedotyczącą tej realizacji. Zapamiętuje kto i kiedy. 
         * @summary Stan działu w realizacji
         * @param {string} processOfferId 
         * @param {RealizationDepartmentDto} department 
         * @param {RealizationDepartmentStatusRequestDto} realizationDepartmentStatusRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationDepartmentStatus(processOfferId: string, department: RealizationDepartmentDto, realizationDepartmentStatusRequestDto: RealizationDepartmentStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto> {
            return localVarFp.updateRealizationDepartmentStatus(processOfferId, department, realizationDepartmentStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Ustawia osobę odpowiedzialną za całą realizację; brak userId czyści przypisanie.
         * @summary Kierownik realizacji
         * @param {string} processOfferId 
         * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRealizationLead(processOfferId: string, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto> {
            return localVarFp.updateRealizationLead(processOfferId, realizationAssigneeRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestRealizationApi - interface
 */
export interface RestRealizationApiInterface {
    /**
     * 
     * @summary Realizacja jednej oferty
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRealization(processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto>;

    /**
     * PDF zlecenia realizacji; z działem — tylko część tego działu. Pobranie zapisuje się w historii realizacji (kto, kiedy, który dział). 
     * @summary Zlecenie realizacji jednej oferty
     * @param {string} processOfferId 
     * @param {RealizationDepartmentDto} [department] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRealizationFile(processOfferId: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Od najnowszego wpisu.
     * @summary Historia realizacji jednej oferty
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRealizationHistory(processOfferId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RealizationLogEntryDto>>;

    /**
     * Oferty w statusach widocznych w kalendarzu, których wydarzenie zaczyna się w podanym zakresie (włącznie, daty polskie), posortowane od najwcześniejszego. Każda pozycja niesie kierownika realizacji i listę działów: działy wynikające z treści oferty oraz zawsze Magazyn, każdy ze stanem, osobą odpowiedzialną i ostatnim pobraniem. 
     * @summary Realizacje w zakresie dat
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRealizations(from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RealizationItemDto>>;

    /**
     * Jeden PDF ze zleceniami realizacji wszystkich realizacji z zakresu (każda od nowej strony), w kolejności jak w liście. Z działem — tylko strony tego działu i tylko realizacje, które go mają. Każde pobranie zapisuje się w historii każdej z tych realizacji. 
     * @summary Zbiorczy PDF zleceń realizacji
     * @param {string} from 
     * @param {string} to 
     * @param {RealizationDepartmentDto} [department] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRealizationsFile(from: string, to: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig): AxiosPromise<File>;

    /**
     * Wpisy historii realizacji, których wydarzenie zaczyna się w zakresie, od najnowszego.
     * @summary Historia realizacji z zakresu
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRealizationsHistory(from: string, to: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RealizationLogEntryDto>>;

    /**
     * Brak userId czyści przypisanie.
     * @summary Osoba odpowiedzialna za dział w realizacji
     * @param {string} processOfferId 
     * @param {RealizationDepartmentDto} department 
     * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRealizationDepartmentResponsible(processOfferId: string, department: RealizationDepartmentDto, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto>;

    /**
     * Oznacza część działu jako zrobioną, z powrotem do zrobienia albo jako niedotyczącą tej realizacji. Zapamiętuje kto i kiedy. 
     * @summary Stan działu w realizacji
     * @param {string} processOfferId 
     * @param {RealizationDepartmentDto} department 
     * @param {RealizationDepartmentStatusRequestDto} realizationDepartmentStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRealizationDepartmentStatus(processOfferId: string, department: RealizationDepartmentDto, realizationDepartmentStatusRequestDto: RealizationDepartmentStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto>;

    /**
     * Ustawia osobę odpowiedzialną za całą realizację; brak userId czyści przypisanie.
     * @summary Kierownik realizacji
     * @param {string} processOfferId 
     * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRealizationLead(processOfferId: string, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<RealizationItemDto>;

}

/**
 * RestRealizationApi - object-oriented interface
 */
export class RestRealizationApi extends BaseAPI implements RestRealizationApiInterface {
    /**
     * 
     * @summary Realizacja jednej oferty
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRealization(processOfferId: string, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).getRealization(processOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * PDF zlecenia realizacji; z działem — tylko część tego działu. Pobranie zapisuje się w historii realizacji (kto, kiedy, który dział). 
     * @summary Zlecenie realizacji jednej oferty
     * @param {string} processOfferId 
     * @param {RealizationDepartmentDto} [department] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRealizationFile(processOfferId: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).getRealizationFile(processOfferId, department, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Od najnowszego wpisu.
     * @summary Historia realizacji jednej oferty
     * @param {string} processOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRealizationHistory(processOfferId: string, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).getRealizationHistory(processOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Oferty w statusach widocznych w kalendarzu, których wydarzenie zaczyna się w podanym zakresie (włącznie, daty polskie), posortowane od najwcześniejszego. Każda pozycja niesie kierownika realizacji i listę działów: działy wynikające z treści oferty oraz zawsze Magazyn, każdy ze stanem, osobą odpowiedzialną i ostatnim pobraniem. 
     * @summary Realizacje w zakresie dat
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRealizations(from: string, to: string, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).getRealizations(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Jeden PDF ze zleceniami realizacji wszystkich realizacji z zakresu (każda od nowej strony), w kolejności jak w liście. Z działem — tylko strony tego działu i tylko realizacje, które go mają. Każde pobranie zapisuje się w historii każdej z tych realizacji. 
     * @summary Zbiorczy PDF zleceń realizacji
     * @param {string} from 
     * @param {string} to 
     * @param {RealizationDepartmentDto} [department] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRealizationsFile(from: string, to: string, department?: RealizationDepartmentDto, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).getRealizationsFile(from, to, department, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wpisy historii realizacji, których wydarzenie zaczyna się w zakresie, od najnowszego.
     * @summary Historia realizacji z zakresu
     * @param {string} from 
     * @param {string} to 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getRealizationsHistory(from: string, to: string, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).getRealizationsHistory(from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Brak userId czyści przypisanie.
     * @summary Osoba odpowiedzialna za dział w realizacji
     * @param {string} processOfferId 
     * @param {RealizationDepartmentDto} department 
     * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRealizationDepartmentResponsible(processOfferId: string, department: RealizationDepartmentDto, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).updateRealizationDepartmentResponsible(processOfferId, department, realizationAssigneeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Oznacza część działu jako zrobioną, z powrotem do zrobienia albo jako niedotyczącą tej realizacji. Zapamiętuje kto i kiedy. 
     * @summary Stan działu w realizacji
     * @param {string} processOfferId 
     * @param {RealizationDepartmentDto} department 
     * @param {RealizationDepartmentStatusRequestDto} realizationDepartmentStatusRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRealizationDepartmentStatus(processOfferId: string, department: RealizationDepartmentDto, realizationDepartmentStatusRequestDto: RealizationDepartmentStatusRequestDto, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).updateRealizationDepartmentStatus(processOfferId, department, realizationDepartmentStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ustawia osobę odpowiedzialną za całą realizację; brak userId czyści przypisanie.
     * @summary Kierownik realizacji
     * @param {string} processOfferId 
     * @param {RealizationAssigneeRequestDto} realizationAssigneeRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateRealizationLead(processOfferId: string, realizationAssigneeRequestDto: RealizationAssigneeRequestDto, options?: RawAxiosRequestConfig) {
        return RestRealizationApiFp(this.configuration).updateRealizationLead(processOfferId, realizationAssigneeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

